import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import Loader from "./loader/loader";

function Contact(
  props: Readonly<{
    indirizzo: string;
    telefono: string;
    mappa: string;
    citta: string;
  }>
) {
  const { t }: { t: any } = useTranslation();

  return (
    <div className=" pt-[2%] pl-[5%]">
      <p className="text-xl md:text-2xl lg:text-3xl 2xl:text-3xl">
        {t("Contacts." + props.citta)}
      </p>
      <Suspense fallback={<Loader />}>
        <iframe title={props.citta} className="w-[80%] pt-[2%]" src={props.mappa}></iframe>
      </Suspense>
      <ul className="pt-[1%]">
        <li>
          {t("Contacts.Address")}: {props.indirizzo}
        </li>
        <li>
          {t("Contacts.Phone")}: {props.telefono}
        </li>
      </ul>
    </div>
  );
}

export default Contact;
